module.exports = __webpack_public_path__ + "img/palmas-hotel-2.d228c0ae.jpg";